module.exports = __webpack_public_path__ + "img/p6.8914ef4b.png";